import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/customers/c9246-190426/frontend/src/app/components/BrandStorySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/customers/c9246-190426/frontend/src/app/components/CategoriesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/customers/c9246-190426/frontend/src/app/components/FeaturedProductsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/customers/c9246-190426/frontend/src/app/components/FounderSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/customers/c9246-190426/frontend/src/app/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/customers/c9246-190426/frontend/src/app/components/NewArrivalsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/customers/c9246-190426/frontend/src/app/components/TestimonialsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/customers/c9246-190426/frontend/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/customers/c9246-190426/frontend/src/components/Header.tsx");
